import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RuleDetail
  from 'Views/Page/Content/Templates/WhatIfTemplate/Components/LinterRuleResultsDrawer/LinterRuleResults/RuleDetail';
import {
  useLinterDrawerContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/LinterDrawer/LinterDrawerContext';

const styles = theme => ({
  root: {
    padding: theme.spacing(0, 4, 4, 4),
  },
  ruleSection: {},
  ruleSectionHeaderText: {
    color: theme.palette.facet.red,
    paddingBottom: theme.spacing(1),
  },
  ruleSectionWarningHeaderText: {
    color: theme.palette.warning.main,
    paddingBottom: theme.spacing(1),
  },
  ruleSectionAlertHeadingText: {
    color: theme.palette.disabled.main,
    paddingBottom: theme.spacing(1),
  },
  ruleResultList: {
    paddingLeft: theme.spacing(1),
  },
});

const LinterRuleResults = ({ className, classes, handleCloseDialog }) => {
  const { linterResults } = useLinterDrawerContext();

  const errors = linterResults?.resources().list().filter(item => item.attr('ruleLevel') === 'error');
  const warnings = linterResults?.resources().list().filter(item => item.attr('ruleLevel') === 'warning');
  const alerts = linterResults?.resources().list().filter(item => item.attr('ruleLevel') === 'alert');

  const errorSection = (
    <div className={classes.ruleSection}>
      <h5 className={classes.ruleSectionHeaderText}>{`Errors (${errors.length})`}</h5>
      <div className={classes.ruleResultList}>
        {errors.map(item => <RuleDetail handleCloseDialog={handleCloseDialog} ruleResultResource={item} key={`ruleDetail-${item.id()} `} />)}
      </div>
    </div>
  );

  const warningSection = (
    <div className={classes.ruleSection}>
      <h5 className={classes.ruleSectionWarningHeaderText}>{`Warnings (${warnings.length})`}</h5>
      <div className={classes.ruleResultList}>
        {warnings.map(item => <RuleDetail handleCloseDialog={handleCloseDialog} ruleResultResource={item} key={`ruleDetail-${item.id()}`} />)}
      </div>
    </div>
  );

  const alertSection = (
    <div className={classes.ruleSection}>
      <h5 className={classes.ruleSectionAlertHeadingText}>{`Alerts (${alerts.length})`}</h5>
      <div className={classes.ruleResultList}>
        {alerts.map(item => <RuleDetail handleCloseDialog={handleCloseDialog} ruleResultResource={item} key={`ruleDetail-${item.id()}`} />)}
      </div>
    </div>
  );

  return (
    <Box
      className={classNames(classes.root, className)}
      test="facet-plan-linter-results"
    >
      {linterResults !== undefined && (
        <div>
          {errorSection}
          {warningSection}
          {alertSection}
        </div>
      )}
    </Box>
  );
};

LinterRuleResults.defaultProps = {
  className: '',
};

LinterRuleResults.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  handleCloseDialog: PropTypes.func.isRequired,
};

export default withStyles(styles)(LinterRuleResults);
